import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import { alertAction } from '../Redux/Actions/alertAction';

const AddInquiry = ({ isShow, setIsShow }) => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const initialValues = { consultant: '', name: '', mobile: '', package: '', followDate: '', followTime: '', enquiryStatus: '', status: '', gender: '', home: '', email: '', pkgPrice: '', remarks: '' };
    const [formErrors, setFormErrors] = useState({})
    const [formValues, setFormValues] = useState(initialValues);
    const [isSubmit, setIsSubmit] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'package' && value === 'Weight Loss') {
            setFormValues({ ...formValues, pkgPrice: 3000, [name]: value })
        }
        else if (name === 'package' && value === 'Weight Gain') {
            setFormValues({ ...formValues, pkgPrice: 2500, [name]: value })
        }
        else {
            setFormValues({ ...formValues, [name]: value });
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setFormErrors(validate(formValues));
        setIsSubmit(true);
        console.log(formValues);
    };
    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmit) {
            navigate('/admin/enquiry/all')
            dispatch(alertAction());
            setIsSubmit(false);
        }
    }, [formErrors, isSubmit])


    const validate = (values) => {
        const errors = {};
        return validation(values, errors);
    };

    useEffect(() => {

        if (slug) {
            setFormValues({ consultant: 'Maria', name: 'Hemal', mobile: '9845056456', package: 'Weight Loss', followDate: '2022-04-11', followTime: '01:20', enquiryStatus: 'Hold', status: 'Active', gender: 'Male', home: 'none', email: 'example@gmai.com', pkgPrice: '3000', remarks: 'none' })
        }
    }, [slug]);

    return (
        <div className='page_first_div'>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div '>
                <p className='page_topic inline-block'>{`${slug ? "Edit" : "Add"} Enquiry`}</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/enquiry/all" className='link block text-white text-sm'>
                        <i className="fa-solid fa-arrow-left mr-1"></i>
                        All
                    </Link>
                </div>
                <section className='page_section px-4 xsm:px-8 py-2 min-h-[25rem]'>
                    <form action="" onSubmit={handleSubmit}>
                        {/* 1st inquiry form */}
                        <div className='grid gap-4 lg:grid-cols-2 lg:gap-6 pt-10'>
                            <div className='font-lato '>
                                <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Consultant<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='consultant' value={formValues.consultant} onChange={handleChange}>
                                    <option value=''>--Select Consultant--</option>
                                    <option value="Maria" className=''>Maria</option>
                                    <option value="Hemant">Hemant</option>
                                    <option value="Rajiv">Rajiv</option>
                                    <option value="Sharan">Sharan</option>
                                </select>
                                <small className='text-red-500 tracking-wide'>{formErrors.consultant}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Name<span className='text-red-500'>&#42;</span>
                                </p>
                                <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide Name' name='name' value={formValues.name} onChange={handleChange} />
                                <small className='text-red-500 tracking-wide'>{formErrors.name}</small>
                            </div>
                            
                            <div className='font-lato '>
                                <p className='text-gray-800 text-sm xsm:text-base font-semibold tracking-wider'>Gender</p>
                                <select className="selector" name='gender' value={formValues.gender} onChange={handleChange}>
                                    <option value=''>--Select Gender--</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Transgender">Transgender</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Mobile Number<span className='text-red-500'>&#42;</span></p>
                                <div className='form_div'>
                                    <input type="number" className='form_input_icon' placeholder='Please Provide Mobile Number' name='mobile' value={formValues.mobile} onChange={handleChange} />
                                    <p className='form_icon_para'>
                                        <i className="fa-solid fa-mobile-screen-button"></i>
                                    </p>
                                </div>
                                <small className='text-red-500 tracking-wide'>{formErrors.mobile}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Home/Other Contact No</p>
                                <div className='form_div'>
                                    <input type="tel" className='form_input_icon' placeholder='Home Phone Number' name='home' value={formValues.home} onChange={handleChange} />
                                    <p className='form_icon_para'>
                                        <i className="fa-solid fa-phone"></i>
                                    </p>
                                </div>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Email</p>
                                <div className='form_div'>
                                    <input type="email" className='form_input_icon' placeholder='Please provide Email' name='email' value={formValues.email} onChange={handleChange} />
                                    <p className='form_icon_para'>
                                        <i className="fa-regular fa-envelope"></i>
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Other Information */}
                        <h3 className='text-gray-800 underline mt-12'>Other Information </h3>
                        <div className='grid gap-4 lg:grid-cols-2 lg:gap-6 pt-8'>
                            <div className='font-lato '>
                                <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Package Interested<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='package' value={formValues.package} onChange={handleChange}>
                                    <option value='' >--Select Package--</option>
                                    <option value="Weight Loss" >Weight Loss</option>
                                    <option value="Weight Gain">Weight Gain</option>
                                </select>
                                <small className='text-red-500 tracking-wide'>{formErrors.package}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Package Offer Price<span className='text-red-500'>&#42;</span></p>
                                <div className='form_div'>
                                    <input type="number" className='form_input_icon' placeholder='Please Provide Package' name='pkgPrice' value={formValues.pkgPrice} onChange={handleChange} disabled />
                                    <p className='form_icon_para'>Rs.</p>
                                </div>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Follow-up Date<span className='text-red-500'>&#42;</span>
                                </p>
                                <input type="date" className='form_input_date border-2 h-10 w-full' name='followDate' value={formValues.followDate} onChange={handleChange} />
                                <small className='text-red-500 tracking-wide'>{formErrors.followDate}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Follow-up Time<span className='text-red-500'>&#42;</span>
                                </p>
                                <input type="time" className='form_input border-2 h-10 w-full' name='followTime' value={formValues.followTime} onChange={handleChange} />
                                <small className='text-red-500 tracking-wide'>{formErrors.followTime}</small>
                            </div>
                            <div className='font-lato '>
                                <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Enquiry Status<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='enquiryStatus' value={formValues.enquiryStatus} onChange={handleChange}>
                                    <option value='' >--Select Enquiry Status--</option>
                                    <option value="Hold" >Hold</option>
                                    <option value="Done">Done</option>
                                </select>
                                <small className='text-red-500 tracking-wide'>{formErrors.enquiryStatus}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Response/feedback/Remarks</p>
                                <textarea className='pl-4 pt-2 text-gray-800 text-sm h-16 w-full outline-none border-2 rounded placeholder:text-xs xsm:placeholder:text-sm' placeholder='Remarks...' name='remarks' value={formValues.remarks} onChange={handleChange}></textarea>
                            </div>
                            <div className='font-lato '>
                                <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Status<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='status' value={formValues.status} onChange={handleChange}>
                                    <option value=''>--Select status--</option>
                                    <option value="Active" className=''>Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                                <small className='text-red-500 tracking-wide'>{formErrors.status}</small>
                            </div>
                        </div>
                        <div className='pt-4 lg:pt-10'>
                            <button className='button mr-2 ' type='submit'>{`${slug ? "Update" : "Save"}`}</button>
                            <button className='button2' type='reset' onClick={() => setFormValues(initialValues)}>Reset</button>
                        </div>
                    </form>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default AddInquiry;

function validation(values, errors) {
    if (values.consultant === '') {
        errors.consultant = "Consultant must be selected!";
    }
    if (values.package === '') {
        errors.package = "Package must be selected!";
    }
    if (!values.name) {
        errors.name = "This field is mandatory!";
    }
    if (!values.mobile) {
        errors.mobile = "This field is mandatory!";
    }
    else if (values.mobile.length < 10) {
        errors.mobile = "Not a valid mobile number!";
    }
    else if (values.mobile.length > 10) {
        errors.mobile = "Not a valid mobile number!";
    }
    if (!values.followDate) {
        errors.followDate = "This field is mandatory!";
    }
    if (!values.followTime) {
        errors.followTime = "This field is mandatory!";
    }
    if (values.enquiryStatus === '') {
        errors.enquiryStatus = "Enquiry status must be selected !";
    }
    if (values.status === '') {
        errors.status = "Status must be selected!";
    }
    return errors;
}
